import { createSlice } from '@reduxjs/toolkit';
import { getProducts } from './thunk';

const productsSlice = createSlice({
  name: 'products',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    
  },

  extraReducers: (builder) => {
    builder
    .addCase(getProducts.pending, (state) => {
      state.loading = true;
    })
    .addCase(getProducts.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
    })
    .addCase(getProducts.rejected, (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    });
    
  }
});


export const productsSliceaction = productsSlice.actions;

export default productsSlice;